import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Search } from "lucide-react";
import api from "../lib/api";
import ListingCard from "../components/ListingCard";

const CATS = ["all", "rifle", "pistol", "revolver"];

export default function Marketplace() {
  const [listings, setListings] = useState([]);
  const [cat, setCat] = useState("all");
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/listings", { params: { category: cat, q: q || undefined } })
      .then((r) => setListings(r.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [cat]);

  return (
    <div className="relative z-10 pt-28 md:pt-36 pb-24 max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="mono-label mb-4">/ Live Inventory</div>
      <h1 className="font-display uppercase text-5xl sm:text-7xl mb-10">The Marketplace</h1>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-12 border-y border-[#5A2A24] py-5">
        <div className="flex flex-wrap gap-2">
          {CATS.map((c) => (
            <button key={c} onClick={() => setCat(c)} data-testid={`filter-${c}`}
              className={`font-mono text-xs uppercase tracking-widest px-4 h-10 border transition-colors ${
                cat === c ? "bg-[#C0894F] border-[#C0894F] text-white" : "border-[#5A2A24] text-[#C7A98F] hover:border-[#EFE4D2] hover:text-[#EFE4D2]"
              }`}>{c}</button>
          ))}
        </div>
        <div className="flex items-center gap-2 md:w-80">
          <div className="relative flex-1">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#8C6552]" />
            <input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()}
              placeholder="Search iron..." data-testid="search-input" className="field pl-9" />
          </div>
          <button onClick={load} className="btn-tactical" data-testid="search-btn">Go</button>
        </div>
      </div>

      {loading ? (
        <div className="font-mono text-[#8C6552] py-20 text-center">LOADING INVENTORY…</div>
      ) : listings.length === 0 ? (
        <div className="font-mono text-[#8C6552] py-20 text-center" data-testid="no-results">NO IRON MATCHES YOUR QUERY.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {listings.map((l, i) => (
            <motion.div key={l.id} initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: (i % 6) * 0.06, ease: [0.76, 0, 0.24, 1] }}>
              <ListingCard listing={l} index={i} />
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
